function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 40,
  height: 40,
  rx: 16,
  fill: "#F8E9BA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.1667 11.2222H28.2778C29.5 11.2222 30.5 12.2222 30.5 13.4444V29C30.5 30.2222 29.5 31.2222 28.2778 31.2222H12.7222C11.4889 31.2222 10.5 30.2222 10.5 29L10.5111 13.4444C10.5111 12.2222 11.4889 11.2222 12.7222 11.2222H13.8333V9H16.0556V11.2222H24.9444V9H27.1667V11.2222ZM12.7222 29H28.2777V17.8889H12.7222V29ZM28.2777 15.6667H12.7222V13.4444H28.2777V15.6667ZM26.0556 21.2222H20.5V26.7778H26.0556V21.2222Z",
  fill: "#121221"
});

function SvgEventPlanning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventPlanning);
export default __webpack_public_path__ + "static/media/EventPlanning.e6e7b606.svg";
export { ForwardRef as ReactComponent };